import useSWR from 'swr';

import {
  HubspotFormFullPage,
  HubspotFormNew,
} from '@/components/forms/HubspotFormNew';

const fetcher = (input: RequestInfo, init: RequestInit) =>
  fetch(input, init).then((res) => res.json());

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const AbFormContainer = ({ hsId, breakPoints }) => {
  const { data: formData } = useSWR(`/api/form/${hsId}`, fetcher);

  if (!formData) return;
  return (
    <HubspotFormNew
      formData={formData}
      variant="fresh"
      endpoint="/api/form/upskiller"
    >
      <HubspotFormFullPage formData={formData} />
    </HubspotFormNew>
  );
};
